export const partnerData = [
  { 
    name: 'University of Utah', 
    logo: '/images/partners/UU_logo.png',
    width: 'auto',
    height: '80px'
  },
  { 
    name: 'NIH', 
    logo: '/images/partners/NIH_logo.png',
    width: 'auto', 
    height: '70px'
  },
  { 
    name: 'Plug and Play', 
    logo: '/images/partners/Plug_and_Play_Logo.png',
    width: 'auto',
    height: '60px'
  },
  { 
    name: 'A2 Collective', 
    logo: '/images/partners/a2_collective_logo.png',
    width: 'auto',
    height: '75px'
  },
  { 
    name: 'Samsung', 
    logo: '/images/partners/samsung_logo.png',
    width: 'auto',
    height: '65px'
  },
  { 
    name: 'Data Science Alliance', 
    logo: '/images/partners/data_science_alliance.webp',
    width: 'auto',
    height: '70px'
  },
  { 
    name: 'MTEC', 
    logo: '/images/partners/mtec_logo.png',
    width: 'auto',
    height: '70px'
  }
];
